export enum EmploymentAgreementStep {
    Unknown = 0,
    Profile = 10,
    PersonalData = 11,
    AwaitingIdentification = 20,
    IdentificationDenied = 21,
    IdentificationCheck = 22,
    NoContractSend = 30,
    AwaitingSigning = 31,
    ExpiredSigning = 32,
    Finished = 100,
    ExpiredContract = 102,
}
